"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _checkbox = require("@atlaskit/checkbox");
var _styles = require("@material-ui/styles");
var _compose = _interopRequireDefault(require("ramda/src/compose"));
var _assocPath = _interopRequireDefault(require("ramda/src/assocPath"));
var _mixins = _interopRequireDefault(require("../../style/mixins"));
var _colors = _interopRequireDefault(require("../../style/colors"));
var _useControlled3 = _interopRequireDefault(require("../../Hook/useControlled"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    hidden: {
      display: 'none'
    },
    label: _objectSpread(_objectSpread({}, theme.typography.smallText), {}, {
      fontSize: '.875rem' // 14px
    })
  };
});
var HiddenInput = function HiddenInput(props /*: { name: string, value: mixed }*/) {
  var classes = useStyles();
  return /*#__PURE__*/React.createElement("input", (0, _extends2.default)({}, props, {
    className: classes.hidden,
    readOnly: true
  }));
};
/*:: type CheckboxInputV2Props = {
  'aria-describedby'?: string,
  'aria-labelledby'?: string,
  defaultValue?: boolean,
  disabled?: boolean,
  displayErrors?: boolean,
  hasError?: boolean,
  id?: string,
  label?: string,
  name?: string,
  onChange?: (
    {
      currentTarget: { id?: string, name?: string, value: boolean }
    },
    SyntheticEvent<HTMLInputElement>,
    Object
  ) => mixed,
  readOnly?: boolean,
  required?: boolean,
  value?: boolean
};*/
var CheckboxInputV2 = function CheckboxInputV2(_ref /*:: */) {
  var ariaDescribedby = _ref /*:: */['aria-describedby'],
    ariaLabelledby = _ref /*:: */['aria-labelledby'],
    _ref$defaultValue = _ref /*:: */.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? false : _ref$defaultValue,
    disabled = _ref /*:: */.disabled,
    displayErrors = _ref /*:: */.displayErrors,
    hasError = _ref /*:: */.hasError,
    id = _ref /*:: */.id,
    label = _ref /*:: */.label,
    name = _ref /*:: */.name,
    onChange = _ref /*:: */.onChange,
    readOnly = _ref /*:: */.readOnly,
    required = _ref /*:: */.required,
    valueProp = _ref /*:: */.value;
  var classes = useStyles();
  var _useControlled = (0, _useControlled3.default)({
      value: valueProp,
      defaultValue: defaultValue,
      name: 'CheckboxInputV2'
    }),
    _useControlled2 = (0, _slicedToArray2.default)(_useControlled, 2),
    value = _useControlled2[0],
    setValueIfUncontrolled = _useControlled2[1];
  var handleChange = React.useCallback(function () {
    if (!readOnly) {
      var _event$currentTarget;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var event = args[0];
      var _value = event === null || event === void 0 ? void 0 : (_event$currentTarget = event.currentTarget) === null || _event$currentTarget === void 0 ? void 0 : _event$currentTarget.checked;
      setValueIfUncontrolled(_value);
      if (typeof onChange === 'function') {
        onChange.apply(void 0, [{
          currentTarget: {
            id: id,
            name: name,
            value: _value
          }
        }].concat(args));
      }
    }
  }, [id, name, onChange, readOnly, setValueIfUncontrolled]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_checkbox.Checkbox, {
    defaultChecked: defaultValue,
    id: id,
    isChecked: value,
    isDisabled: disabled,
    isInvalid: displayErrors && (required && !value || hasError),
    isRequired: required,
    label: typeof label === 'string' ? /*#__PURE__*/React.createElement("span", {
      className: classes.label
    }, label) : undefined,
    onChange: handleChange
    // Reference: https://atlaskit.atlassian.com/packages/design-system/checkbox/example/theming
    ,
    theme: function theme(current, props) {
      var themeTokens = current(props);
      return (0, _compose.default)((0, _assocPath.default)(['icon', 'borderColor', 'invalid'], _colors.default.error), (0, _assocPath.default)(['icon', 'borderColor', 'invalidAndChecked'], _colors.default.error), (0, _assocPath.default)(['requiredIndicator', 'textColor', 'rest'], _colors.default.error), (0, _assocPath.default)(['label', 'textColor', 'disabled'], _mixins.default.inputDisabled.color))(themeTokens);
    },
    value: value
  }), typeof name === 'string' && name.length > 0 && /*#__PURE__*/React.createElement(HiddenInput, {
    "aria-describedby": ariaDescribedby,
    "aria-labelledby": ariaLabelledby,
    name: name,
    value: value
  }));
};
var _default = exports.default = CheckboxInputV2;
//# sourceMappingURL=CheckboxInputV2.js.map